import { useThree } from '@react-three/fiber';
import { ReactNode, createContext, useContext } from 'react';

type QualityContextType = {
  highQuality: boolean;
};

const QualityContext = createContext<QualityContextType>({ highQuality: true });

type Props = { children: ReactNode };
export const AdaptativeQuality = ({ children }: Props) => {
  const maxTextureSize = useThree(
    state => state.gl.capabilities.maxTextureSize
  );

  return (
    // use maxTextureSize as an indicator of the device capability to run 3d code
    <QualityContext.Provider value={{ highQuality: maxTextureSize > 16000 }}>
      {children}
    </QualityContext.Provider>
  );
};

export const useHighQuality = () => useContext(QualityContext).highQuality;
